module.exports = __webpack_public_path__ + "img/bg_form_small_screen.d87274cc.svg";